export default __webpack_public_path__ + "static/media/köide-15-16.60ff31d9.png";